import { __decorate } from "tslib";
import { Button } from '@microsoft/fast-foundation';
import { attr } from '@microsoft/fast-element';
import { ensureDefaultAttribute } from '../common/utils/Attributes';
import { ChameleonElementMixin } from '../common/ChameleonElement';
export class IconButtonComponent extends ChameleonElementMixin(Button) {
    connectedCallback() {
        super.connectedCallback();
        ensureDefaultAttribute(this, 'size', 'medium');
        ensureDefaultAttribute(this, 'variant', 'primary');
    }
}
__decorate([
    attr
], IconButtonComponent.prototype, "size", void 0);
__decorate([
    attr
], IconButtonComponent.prototype, "variant", void 0);
